import type { IntlShape } from '@atlassian/jira-intl';
import {
	ESTIMATION_STORY_POINTS,
	ESTIMATION_ISSUE_COUNT,
	ESTIMATION_ORIGINAL_ESTIMATE,
} from '@atlassian/jira-software-report-charting-common/src/common/utils/format-estimate/index.tsx';
import type {
	Sprint,
	SprintReportsEstimationStatistic,
	EstimationFieldOption,
	SprintOption,
} from '../../common/types';
import { getSprintFilterRank } from '../../common/utils/filters';
import commonMessages from './messages';

export const optionForStatistic = (
	statistic: SprintReportsEstimationStatistic,
	intl: IntlShape,
): EstimationFieldOption => {
	if (statistic === ESTIMATION_ISSUE_COUNT) {
		return {
			label: intl.formatMessage(commonMessages.optionStatisticIssueCount),
			value: ESTIMATION_ISSUE_COUNT,
		};
	}

	if (statistic === ESTIMATION_ORIGINAL_ESTIMATE) {
		return {
			label: intl.formatMessage(commonMessages.optionStatisticOriginalEstimate),
			value: ESTIMATION_ORIGINAL_ESTIMATE,
		};
	}

	return {
		label: intl.formatMessage(commonMessages.optionStatisticStoryPoints),
		value: ESTIMATION_STORY_POINTS,
	};
};

export const optionForSprint = (sprint: Sprint): SprintOption => ({
	sprint,
	label: sprint.name,
	value: sprint.id,
});

export const getSprintFilterEventAttributes = (
	sprints: Sprint[] | null,
	sprint: Sprint | null,
): {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	[key: string]: any;
} => ({
	sprintFilterRank: getSprintFilterRank(sprints, sprint && sprint.id),
	totalSprints: sprints && sprints.length,
});
